var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.validations),function(validation){return _c('b-alert',{key:validation.id,staticClass:"mb-2",attrs:{"show":"","variant":_vm.validationType(validation)}},[_vm._v(_vm._s(validation.message))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }